import { gql } from "@apollo/client";

export const GET_HOLIDAYS_BY_COUNTRY = gql`
  query getHolidaysByCountry($countryIds: [Int!]!) {
    getHolidaysByCountry(countryIds: $countryIds) {
      id
      countryId
      holidayName
      holidayDate
      categories
      requiresAdjustment
      adjustmentRule
      icon
      notes
      color
      annualSpecialDates {
        date
        name
        color
      }
    }
  }
`;

export const GET_HOLIDAYS_BY_COUNTRY_AND_MONTH = gql`
  query GetHolidaysByCountryAndMonth($countryIds: [Int!]!, $currentMonth: String!) {
    getHolidaysByCountryAndMonth(countryIds: $countryIds, currentMonth: $currentMonth) {
      id
      countryId  
      holidayName
      holidayDate
      categories
      requiresAdjustment
      adjustmentRule
      icon
      notes
      color
      annualSpecialDates {
        date
        name
        color
      }
    }
  }
`;

export const GET_HOLIDAYS_BY_CATEGORY = gql`
  query getHolidaysByCategory($countryId: Int!, $category: CategoryEnum!) {
    getHolidaysByCategory(countryId: $countryId, category: $category) {
      id
      holidayName
      holidayDate
      categories
      requiresAdjustment
      adjustmentRule
      icon
      notes
      color
      annualSpecialDates {
        date
        name
        color
      }
    }
  }
`;
